export const compose = (...fns) => (...args) => fns.reduceRight((agg, cur) => [cur.apply(this, agg)], args)[0];


// WEBPACK FOOTER //
// ./src/actions/index.js